export default __webpack_public_path__ + "static/GT-America-Compressed-Medium-8288b4058f2f19b2dc62d7dc282e5002.ttf";